import type { CreateOneShopWebhookDto, ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddWebhook(shop: ShopDto) {
	return useApiMutation("post", "/shops/{shopId}/webhooks", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (body: CreateOneShopWebhookDto) => ({
			params: { path: { shopId: shop.id } },
			body,
		}),
	});
}
